import svg132 from "../../../assets/svg/svg132.svg";
import svg133 from "../../../assets/svg/svg133.svg";
import svg134 from "../../../assets/svg/svg134.svg";
import svg135 from "../../../assets/svg/svg135.svg";

function PersonalNumbers() {
  const stats = [
    {
      id: 1,
      icon: svg132,
      label: "Speed",
      value: "30s Avg",
      description:
        "Processing time for median end‑to‑end processing across major rails.",
    },
    {
      id: 2,
      icon: svg133,
      label: "Scale",
      value: "850M+",
      description:
        "moved through Ndovu Pay Personal wallets this year. Fast, secure, and verified.",
    },
    {
      id: 3,
      icon: svg134,
      label: "Reach",
      value: "120K+",
      description: "personal users actively making payments monthly",
    },
    {
      id: 4,
      icon: svg135,
      label: "Reliability",
      value: "99.99%",
      description:
        "Speed you can count on, almost every Ndovu Pay transaction completes instantly.",
    },
  ];

  return (
    <>
      <div className="flex items-center flex-col justify-center  ">
        <div className="flex items-center text-lighGold">
          <span className="w-[1.25rem] h-[0.09375rem] "></span>
          <span className="text-[1rem] font-[500] leading-[1.625rem] uppercase">
            Our numbers
          </span>
        </div>

        <div className="mt-[1rem] text-[#000] text-[2.25rem] font-[500] leading-[2.625rem] lg:w-[480px] w-full  text-center">
          Powering Everyday Payments at Scale
        </div>
      </div>

      <div className="mt-[3.5rem] grid lg:grid-cols-4 grid-cols-1 gap-[2.62rem]">
        {stats &&
          stats?.map((item) => (
            <div className="h-[17.1875rem] rounded-[1.25rem] bg-white  numbers-card px-[2rem] py-[2.5rem] border border-[#FBFBFE]">
              <div className="gap-[.5rem] flex items-center text-[#000] text-[1.125rem] font-[600] leading-[1.625rem]">
                <img src={item?.icon} alt={item?.icon} /> {item?.label}
              </div>

              <div className="mt-[2.5rem] text-[#1E191B] text-[2.875rem] font-[600] leading-[3.375rem]">
                {item?.value}
              </div>

              <div className="mt-[.75rem] text-[#7A7493] text-[.875rem] font-[400]">
                {item?.description}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default PersonalNumbers;
